module.exports = __webpack_public_path__ + "static/media/icon_more2.7d816b5e.svg";